import type { PersonioLinkMemberFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";
import { UserPicker } from "@/components/pickers/user-picker";

/** Props Interface */
interface PersonioLinkMemberFormProps {
	excludeUserIds: string[];
}

export function PersonioLinkMemberForm({ excludeUserIds }: PersonioLinkMemberFormProps) {
	/** Hooks */
	const methods = useFormContext<PersonioLinkMemberFormSchema>();

	/** Render */
	return (
		<UserPicker
			control={methods.control}
			name="userId"
			excludeUserIds={excludeUserIds}
		/>
	);
}
